export enum Suit {
    HEARTS = 0,
    DIAMONDS = 1,
    CLUBS = 2,
    SPADES = 3,
}

export const Suits: Suit[] = [
    Suit.HEARTS,
    Suit.DIAMONDS,
    Suit.CLUBS,
    Suit.SPADES,
];
